'use client';
import cn from 'classnames';
import styles from './EmptyPageBlock.module.scss';
import { Button } from '@/atoms/Button';

type EmptyPageBlockProps = {
  className?: string;
  title: string;
  description?: string;
  button?: {
    text: string;
    onClick: () => void;
  };
};

export function EmptyPageBlock({
  className,
  title,
  description,
  button,
}: EmptyPageBlockProps) {
  const wrapperClassName = cn(styles.wrapper, className);

  return (
    <div className={wrapperClassName}>
      <div className={styles.content}>
        <img src="/png/fail.png" alt="404" className={styles.image} />
        <div className={styles.text}>
          <p className={styles.title}>{title}</p>
          <p className={styles.description}>{description}</p>
        </div>
        {button && (
          <Button
            text={button.text}
            onClick={button.onClick}
            className={styles.button}
            variant="primary"
          />
        )}
      </div>
    </div>
  );
}
